// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"1927bdb8","71":"252c4307","100":"122e43a4","191":"d9ee4e18","263":"a14f5e22","405":"5d5dbe75","409":"91815faa","547":"035462f5","707":"b49ea9ca","776":"17f76477"}[chunkId] + ".chunk.js";
};